__turbopack_context__.v({
  "counter": "FormCurrencyField-module-scss-module__mcIT5q__counter",
  "disabled": "FormCurrencyField-module-scss-module__mcIT5q__disabled",
  "error": "FormCurrencyField-module-scss-module__mcIT5q__error",
  "errorMsg": "FormCurrencyField-module-scss-module__mcIT5q__errorMsg",
  "field": "FormCurrencyField-module-scss-module__mcIT5q__field",
  "fieldDescription": "FormCurrencyField-module-scss-module__mcIT5q__fieldDescription",
  "input": "FormCurrencyField-module-scss-module__mcIT5q__input",
  "inputContent": "FormCurrencyField-module-scss-module__mcIT5q__inputContent",
  "inputElement": "FormCurrencyField-module-scss-module__mcIT5q__inputElement",
  "label": "FormCurrencyField-module-scss-module__mcIT5q__label",
  "labelWrapper": "FormCurrencyField-module-scss-module__mcIT5q__labelWrapper",
  "required": "FormCurrencyField-module-scss-module__mcIT5q__required",
  "sub": "FormCurrencyField-module-scss-module__mcIT5q__sub",
});
